import { matchPath } from 'react-router-dom';
import { getGroceriesPageName } from './getGroceriesPageName';
import { getRecipesPageName } from './getRecipesPageName';
import { PATH_PAGE_NAME_MAPPINGS } from './pageNameMappings';

const pageNameKeys = Object.keys(PATH_PAGE_NAME_MAPPINGS);

export function getPathPageName() {
  const url = new URL(window.location.href);
  const pathname = url.pathname;

  for (const key of pageNameKeys) {
    if (
      matchPath(pathname, {
        path: key,
        exact: true,
        strict: false,
      })
    ) {
      return PATH_PAGE_NAME_MAPPINGS[
        key as keyof typeof PATH_PAGE_NAME_MAPPINGS
      ];
    }
  }

  const recipesPageName = getRecipesPageName();

  if (recipesPageName) {
    return recipesPageName;
  }

  const groceriesPageName = getGroceriesPageName();

  if (groceriesPageName) {
    return groceriesPageName;
  }

  return null;
}
